import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'firstChart'})
export class FirstChartPipe implements PipeTransform {
  transform(value: string): string {
    if(value != null && value != '') return value.substr(0,1);
  }
}